<template>
  <div class="main">
    <Header
      :show="true"
      title="地磅道闸"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="请先观察现场情况，在确保安全的情况下放行。"
      />
      <van-form>
        <van-cell
          :value="listQuery.area.name"
          is-link
          required
          @click="listQuery.area.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">放行位置</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.area.show"
          :actions="listQuery.area.actions"
          cancel-text="取消"
          description="请选择放行位置"
          @select="onSelectAreaChoose"
        />
        <van-cell
          :value="listQuery.reason.name"
          is-link
          required
          @click="listQuery.reason.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">放行理由</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.reason.show"
          :actions="listQuery.reason.actions"
          cancel-text="取消"
          description="请选择放行理由"
          @select="onSelectReasonChoose"
        />
        <div
          v-if="checkPermission([252])"
          style="margin: 16px"
        >
          <van-button
            round
            block
            type="info"
            @click="handleOperateConfirmDialog"
          >
            确定
          </van-button>
        </div>
      </van-form>

      <van-dialog
        v-model="dialogVisibleOperate"
        title="确认放行？"
        show-cancel-button
        :before-close="handleBeforeCloseDialog"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2vh;
            margin: 20px 0;
          "
        >
          放行位置：{{ listQuery.area.name }}
        </div>
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { updateOne } from "@/api/weigh.js";

export default {
  name: "ServiceControlWeigh",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      dialogVisibleOperate: false,
      listQuery: {
        area: {
          show: false,
          actions: [
            { name: "皮重上磅前杆" },
            { name: "毛重上磅前杆" },
            { name: "皮重出磅后杆" },
            { name: "毛重出磅后杆" },
          ],
          name: "皮重上磅前杆",
        },
        reason: {
          show: false,
          actions: [
            { name: "临时放行", subname: "" },
            { name: "系统故障" },
            { name: "其他" },
          ],
          name: "",
        },
      },
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    handleClickRight() {
      this.$router.push({
        path: "/service/system/staff/create",
        query: {},
      });
    },
    onSelectAreaChoose(item) {
      this.listQuery.area.show = false;
      this.listQuery.area.name = item.name;
    },
    onSelectReasonChoose(item) {
      this.listQuery.reason.show = false;
      this.listQuery.reason.name = item.name;
    },
    handleOperateConfirmDialog() {
      if (this.listQuery.reason.name === "") {
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          500,
          "地磅道闸放行",
          "请选择放行事由"
        );
      } else {
        this.dialogVisibleOperate = true;
      }
    },
    handleBeforeCloseDialog(action, done) {
      const { name, actions } = this.listQuery.area;
      if (action === "confirm") {
        const act = actions.filter((act) => act.name === name);
        const rail = actions.indexOf(act[0]) + 1;
        const data = {
          rail: rail,
          reason: this.listQuery.reason.name,
        };
        updateOne(data)
          .then((response) => {
            const { data } = response;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "地磅道闸放行",
                data.message
              )
            ) {
              done(true);
            }
            this.dialogVisibleDelete = false;
          })
          .catch(function (error) {
            console.error(error);
          });
      } else {
        showPhoneAlarm(true, "toast", "success", 2000, 200, null, "取消放行");
        done(true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改

// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
